import { baseApi } from "../baseApi";

export const salesInvoiceAuricApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPaymentDetails: builder.query({
      query: (pdata) => ({
        url: '/api/method/frappe.client.get',
        params: pdata,
      }),
    }),
    postSalesInvoiceListApi: builder.mutation({
      query: (body) => ({
        url: `/api/method/frappe.desk.reportview.get`,
        method: 'POST',
        body
      }),
    }),
    postItemScanApi: builder.mutation({
      query: (body) => ({
        url: `/api/method/frappe.client.get`,
        method: 'POST',
        body
      }),
    }),
    postPartSalesDataApi: builder.mutation({
      query: (body) => ({
        url: `/api/method/jewellery.utils.sale_invoice.get_purchase_receipt_by_serial`,
        method: 'POST',
        body
      }),
    }),
    postSalesInvoicedCountApi: builder.mutation({
      query: (body) => ({
        url: `/api/method/frappe.desk.reportview.get_count`,
        method:'POST',
        body
      }),
    }),
    postAdvancePaymentApi: builder.mutation({
      query: (body) => ({
        url: `/api/method/frappe.desk.reportview.get`,
        method:'POST',
        body
      }),
    }),
    postShippingAddressApi: builder.mutation({
      query: (body) => ({
        url: `/api/method/frappe.contacts.doctype.address.address.get_address_display`,
        method:'POST',
        body
      }),
    }),
  }),
});

export const {
  usePostSalesInvoiceListApiMutation,
  usePostSalesInvoicedCountApiMutation,
  usePostItemScanApiMutation,
  usePostAdvancePaymentApiMutation,
  usePostShippingAddressApiMutation,
  useGetPaymentDetailsQuery,
  useLazyGetPaymentDetailsQuery,
  usePostPartSalesDataApiMutation
} = salesInvoiceAuricApi;
